import { defineAsyncComponent } from "vue";

const AppFooter = defineAsyncComponent(() => import("./app-footer.vue"));

export default {AppFooter};